import { TSelector } from "../../store/typing/types";
import {
  IBonusesListSelector,
  IBonusesListItemSelector,
  IBonusesRulesSelector,
} from "./typing/BonusesList.interface";
import { RootState } from "../../store/rootStore";
import { createSelector } from "reselect";
import { IBonus } from "../../store/models/bonuses/typing/bonuses.interface";

// export const bonusesListSelector: TSelector<IBonusesListSelector> = ({
//   bonuses: { bonuses },
// }) => {
//   return {
//     bonuses,
//   };
// };

// export const bonusesListItemSelector: TSelector<IBonusesListItemSelector> = ({
//   user: {
//     verification,
//     contacts: { emailConfirmation, phoneConfirmation },
//   },
//   authorization: { auth },
// }) => {
//   return {
//     auth,
//     verification,
//     emailConfirmation,
//   };
// };

const selectBonuses = (state: RootState) => state.bonuses.bonuses;
const selectUser = (state: RootState) => state.user;
const selectAuthorization = (state: RootState) => state.authorization;

export const bonusesListSelector: (
  page: number,
  perPage: number,
  isMobile: boolean
) => TSelector<IBonusesListSelector> = (page, perPage, isMobile) =>
  createSelector(selectBonuses, (bonuses) => {
    if (!bonuses || !bonuses[`${page}_${perPage}`]) {
      return {
        bonuses: [],
        count: 0,
        mainBonus: undefined,
      };
    }

    if (!isMobile) {
    }
    const allBonuses: IBonus[] = Object.values(bonuses).flatMap(
      (pageData) => pageData?.bonuses || []
    );

    let mainBonus: IBonus | undefined;

    // Якщо не мобільний пристрій, фільтруємо по chain бонусах
    if (!isMobile) {
      mainBonus = allBonuses
        .filter((el) => el.sub_type === "chain") // Фільтруємо тільки chain-бонуси
        .reduce(
          (min, el) => (min && min.id < el.id ? min : el),
          undefined as IBonus | undefined
        );
    }

    const updatedBonuses: Record<string, { bonuses: IBonus[]; count: number }> =
      {};
    const updatedArchivedBonuses: Record<
      string,
      { bonuses: IBonus[]; count: number }
    > = {};

    for (const key in bonuses) {
      if (Object.prototype.hasOwnProperty.call(bonuses, key)) {
        const pageData = bonuses[key];

        if (!pageData) continue;

        const filteredBonuses = pageData.bonuses.filter(
          (el) => !(mainBonus && el.id === mainBonus.id)
        );

        updatedBonuses[key] = {
          bonuses: filteredBonuses,
          count: filteredBonuses.length,
        };
      }
    }

    const currentPageData = updatedBonuses[`${page}_${perPage}`] || {
      bonuses: [],
      count: 0,
    };

    return {
      bonuses: currentPageData.bonuses,
      count: currentPageData.count,
      mainBonus,
    };
  });

export const bonusesListItemSelector: TSelector<IBonusesListItemSelector> =
  createSelector(
    selectUser,
    selectAuthorization,
    (
      { verification, contacts: { emailConfirmation, phoneConfirmation } },
      { auth }
    ) =>
      ({
        auth,
        verification,
        emailConfirmation,
      } as IBonusesListItemSelector)
  );

export const bonusesRulesSelector: TSelector<IBonusesRulesSelector> =
  createSelector(
    selectUser,
    selectAuthorization,
    ({ wallets }, { auth }) =>
      ({
        auth,
        active_wallet_currency: wallets.filter((wallet) => wallet.active)[0]
          ? wallets.filter((wallet) => wallet.active)[0].currency.name
          : undefined,
      } as IBonusesRulesSelector)
  );
